import React from 'react';
import styled from "styled-components";

export const PageContainer = styled.div`
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 1em;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    background-color: #fadeba;
`